"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculateMonthlyMortgagePayments_1 = require("./internal/calculateMonthlyMortgagePayments");
const calculateMaximumBorrowingCapacity_1 = require("./internal/calculateMaximumBorrowingCapacity");
const calculateInterestRate_1 = require("./internal/calculateInterestRate");
const calculateSavingsAtMaturity_1 = require("./internal/calculateSavingsAtMaturity");
const calculateSavingsMonthlyObjective_1 = require("./internal/calculateSavingsMonthlyObjective");
exports.getMonthlyPayments = (loanAmount, interestRate, months) => {
    if (!loanAmount ||
        interestRate == null ||
        !months ||
        isNaN(loanAmount) ||
        isNaN(interestRate) ||
        isNaN(months) ||
        months < 0 ||
        loanAmount < 0) {
        throw 'Either there are missing/invalid params, or one of "loanAmount" or "months" is equal to 0 or is negative, which is not possible';
    }
    return +calculateMonthlyMortgagePayments_1.default(+loanAmount, +interestRate, +months).toFixed(2);
};
exports.getMaximumBorrowingCapacity = (availableRevenue, interestRate, months, maximumDebtRatio) => {
    if (!availableRevenue ||
        interestRate == null ||
        !months ||
        !maximumDebtRatio ||
        isNaN(availableRevenue) ||
        isNaN(interestRate) ||
        isNaN(months) ||
        isNaN(maximumDebtRatio) ||
        maximumDebtRatio < 0 ||
        maximumDebtRatio > 100 ||
        months < 0 ||
        availableRevenue < 0) {
        throw 'Either there are missing/invalid params, or one of "availableRevenue", "months" or "maximumDebtRatio" is equal to 0 or is negative, which is not possible';
    }
    return calculateMaximumBorrowingCapacity_1.default(+availableRevenue, +interestRate, +months, +maximumDebtRatio);
};
exports.getInterestRate = (loanAmount, monthlyPayments, months) => {
    if (!loanAmount ||
        !monthlyPayments ||
        !months ||
        isNaN(loanAmount) ||
        isNaN(monthlyPayments) ||
        isNaN(months) ||
        loanAmount < 0 ||
        months < 0 ||
        monthlyPayments < 0) {
        throw 'Either there are missing/invalid params, or one of "loanAmount", "months" or "monthlyPayments" is equal to 0 or is negative, which is not possible';
    }
    return calculateInterestRate_1.default(+loanAmount, +monthlyPayments, +months);
};
exports.getSavingsCapitalAtMaturity = (initialCapital, yearlyInterest, months, monthlyPayments) => {
    if (!months ||
        initialCapital == null ||
        yearlyInterest == null ||
        (monthlyPayments != null && isNaN(monthlyPayments)) ||
        isNaN(initialCapital) ||
        isNaN(yearlyInterest) ||
        isNaN(months) ||
        initialCapital < 0 ||
        months < 0) {
        throw 'Either there are missing/invalid params, or "months" is <= 0 or "initialCapital" is negative, which is not possible';
    }
    return +calculateSavingsAtMaturity_1.default(+initialCapital, +yearlyInterest, +months, +monthlyPayments).toFixed(2);
};
exports.getSavingsMonthlyObjective = (initialCapital, yearlyInterest, months, objectiveCapital) => {
    if (!months ||
        objectiveCapital == null ||
        yearlyInterest == null ||
        initialCapital == null ||
        isNaN(initialCapital) ||
        isNaN(yearlyInterest) ||
        isNaN(objectiveCapital) ||
        isNaN(months) ||
        months < 0 ||
        initialCapital < 0 ||
        objectiveCapital < 0 ||
        objectiveCapital <= initialCapital) {
        throw 'Either there are missing/invalid params, or one of the followings: "months" is <= 0, "initialCapital" or "objectiveCapital" is negative, or objectiveCapital is lower than initialCapital which is not allowed';
    }
    return +calculateSavingsMonthlyObjective_1.default(+initialCapital, +yearlyInterest, +months, +objectiveCapital).toFixed(2);
};
exports.default = {
    getMonthlyPayments: exports.getMonthlyPayments,
    getMaximumBorrowingCapacity: exports.getMaximumBorrowingCapacity,
    getInterestRate: exports.getInterestRate,
    getSavingsCapitalAtMaturity: exports.getSavingsCapitalAtMaturity,
    getSavingsMonthlyObjective: exports.getSavingsMonthlyObjective,
};
